import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Input from "../../../../../../components/textbox/Input";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../../utils/Utils";
import $ from 'jquery'
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";

class SezioneDieci extends Component {

    state = {
        sezioneDieci: {
            ast: null,
            alt: null,
            bilirubinaTotale: null,
            bilirubinaDiretta: null,
            inr: null
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
        this.onKeyDown = this.onKeyDown.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneDieci) {
            let sezioneDieci = this.state.sezioneDieci
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneDieci))
            sezioneDieci.ast = propsSezione.ast ? propsSezione.ast : null
            sezioneDieci.alt = propsSezione.alt ? propsSezione.alt : null
            sezioneDieci.bilirubinaDiretta = propsSezione.bilirubinaDiretta ? propsSezione.bilirubinaDiretta : null
            sezioneDieci.bilirubinaTotale = propsSezione.bilirubinaTotale ? propsSezione.bilirubinaTotale : null
            sezioneDieci.inr = propsSezione.inr ? propsSezione.inr : null
            this.setState({sezioneDieci: sezioneDieci});
        }
        this.props.setSezioneDieci(this.state.sezioneDieci)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneDieci(this.state.sezioneDieci, res)
        }

        this.onKeyDown();
    }

    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneDieci))
        let sezioneBackend = Utils.removeEmptyValueFromObject(dati)
        return Utils.removeFieldFromObject(sezioneBackend, "corretto")
    }


    riceviValoreInput(field, event) {
        let sezioneDieci = this.state.sezioneDieci
        if (field.currentTarget) {
            sezioneDieci[field.currentTarget.id] = field.currentTarget.value
        } else {
            sezioneDieci[field] = event.target.value
        }
        this.setState({sezioneDieci: sezioneDieci})
    }

    onKeyDown() {

        $('#INR').keypress(function (event) {
            if (event.which === 8 || event.which === 0) {
                return true;
            }
            if (event.which < 44 || event.which === 46 || event.which > 59) {
                return false;
            }

            if (($(this).val().toString()).split('.')[1] && ($(this).val().toString()).split('.')[1].length === 2) {
                return false;
            }
        });
    }

    render() {

        const {t} = this.props


        const sezione = (
            <div>
                <div>
                    <h6>Sezione 10</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row">
                        <div className="col-lg-2">
                            <div className="row">
                                <div className="col-lg-3">
                                    <p className={styles.testo}
                                       style={{textAlign: "right"}}>{this.props.t("SchedaEpatite.sezione10.ast")}
                                    </p>
                                </div>
                                <div className={`col-lg-9 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello5' : ''}`}>
                                    <Input id={"ast"}
                                           type="number"
                                           min="0"
                                           max="9999"
                                           onChange={this.riceviValoreInput}
                                           field={"ast"}
                                           value={this.state.sezioneDieci.ast}
                                           placeholder={"AST"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="row">
                                <div className="col-lg-3">
                                    <p className={styles.testo}
                                       style={{textAlign: "right"}}>{this.props.t("SchedaEpatite.sezione10.alt")}
                                    </p>
                                </div>
                                <div className={`col-lg-9 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                                    <Input id={"alt"}
                                           type="number" min="0" max="9999"
                                           onChange={this.riceviValoreInput}
                                           field={"alt"}
                                           value={this.state.sezioneDieci.alt}
                                           placeholder={"ALT"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.testo}
                                       style={{marginTop: "0px"}}>{this.props.t("SchedaEpatite.sezione10.bilirubinaTotale")}
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                    <Input id={"birubilinaTotale"}
                                           type="number"
                                           step="0.1"
                                           min="0" max="99.9"
                                           onChange={this.riceviValoreInput}
                                           field={"bilirubinaTotale"}
                                           value={this.state.sezioneDieci.bilirubinaTotale}
                                           placeholder={"tot"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.testo}
                                       style={{marginTop: "0px"}}>{this.props.t("SchedaEpatite.sezione10.bilirubinaDiretta")}
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"bilirubinaDiretta"}

                                           type="number"
                                           step="0.1" min="0" max="99.9"
                                           onChange={this.riceviValoreInput}
                                           field={"bilirubinaDiretta"}
                                           value={this.state.sezioneDieci.bilirubinaDiretta}
                                           placeholder={"dir"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="row">
                                <div className="col-lg-3">
                                    <p className={styles.testo}
                                       style={{textAlign: "right"}}>{this.props.t("SchedaEpatite.sezione10.inr")}
                                    </p>
                                </div>
                                <div className={`col-lg-9 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"inr"}
                                           type="number"
                                           step="0.01" min="0"
                                           max="9.99"
                                           onChange={this.riceviValoreInput}
                                           field={"inr"}
                                           value={this.state.sezioneDieci.inr}
                                           placeholder={"INR"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        );


        return <div>

            {sezione}
        </div>
    }


}

export default withTranslation('common')(SezioneDieci)
